export default ({ request }) => ({

// 供应商资料文件相关接口

  scmInfoDocListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoDoc/list',
      method: 'post',
      data
    })
  },
  scmInfoDocDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfoDoc/detail',
      method: 'post',
      data
    })
  },
  scmInfoDocAddApi(data) {
    return request({
      url: '/digitalCenter/scmInfoDoc/add',
      method: 'post',
      data
    })
  },
  scmInfoDocUpdateApi(data) {
    return request({
      url: '/digitalCenter/scmInfoDoc/update',
      method: 'post',
      data
    })
  }
})
